var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_4324",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_4324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12 -1C16.6445 -1 20.9361 1.47779 23.2583 5.5L12 12Z",
    fill: "#FFA800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L23.2583 5.5C25.5806 9.52221 25.5806 14.4778 23.2583 18.5L12 12Z",
    fill: "#FD4158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L23.2583 18.5C20.9361 22.5222 16.6445 25 12 25L12 12Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V25C7.35555 25 3.06389 22.5222 0.741669 18.5L12 12Z",
    fill: "#FFA800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L0.74167 18.5C-1.58056 14.4778 -1.58056 9.52221 0.74167 5.5L12 12Z",
    fill: "#FD4158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L0.741669 5.5C3.06389 1.47779 7.35555 -1 12 -1V12Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12 -1C16.6445 -1 20.9361 1.47779 23.2583 5.5L12 12Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L23.2583 5.5C25.5806 9.52221 25.5806 14.4778 23.2583 18.5L12 12Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L23.2583 18.5C20.9361 22.5222 16.6445 25 12 25L12 12Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V25C7.35555 25 3.06389 22.5222 0.741669 18.5L12 12Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L0.74167 18.5C-1.58056 14.4778 -1.58056 9.52221 0.74167 5.5L12 12Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L0.741669 5.5C3.06389 1.47779 7.35555 -1 12 -1V12Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14ZM20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
    fill: "#FF998B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26795 6.07189C6.82024 7.02848 8.04342 7.35623 9 6.80395C9.95659 6.25166 10.2843 5.02848 9.73206 4.07189C9.17977 3.11531 7.95659 2.78756 7 3.33984C6.04342 3.89213 5.71567 5.11531 6.26795 6.07189ZM14.268 19.9283C14.8202 20.8849 16.0434 21.2126 17 20.6604C17.9566 20.1081 18.2843 18.8849 17.7321 17.9283C17.1798 16.9717 15.9566 16.644 15 17.1963C14.0434 17.7485 13.7157 18.9717 14.268 19.9283Z",
    fill: "#23B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.268 4.07189C13.7157 5.02848 14.0434 6.25166 15 6.80395C15.9566 7.35623 17.1798 7.02848 17.7321 6.07189C18.2843 5.11531 17.9566 3.89213 17 3.33984C16.0434 2.78756 14.8202 3.11531 14.268 4.07189ZM6.26795 17.9283C5.71567 18.8849 6.04342 20.1081 7 20.6604C7.95659 21.2126 9.17977 20.8849 9.73205 19.9283C10.2843 18.9717 9.95659 17.7485 9 17.1962C8.04342 16.644 6.82024 16.9717 6.26795 17.9283Z",
    fill: "#FFD540"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.78c53fcb7b1323b56021e4006f51d22f.svg";
export { ForwardRef as ReactComponent };